import { useEffect, useState } from 'react'
import { PaytrieAPI } from '@paytrie/client'

import { getUserTokenPreference } from '@/utils/userPreferences'
import { usePageStateStore } from '@/reducers'
import { useBuySellStore } from '@/reducers/transactionReducer'
import { useFeatureFlags } from '@/contexts/FeatureFlagsContext'

export const useUserPreferences = () => {
  const [preferencesLoaded, setPreferencesLoaded] = useState(false)
  const [preferencesApplied, setPreferencesApplied] = useState(false)
  const authToken = usePageStateStore.use.authToken()
  const setNetwork = useBuySellStore.use.setNetwork()
  const setStableCoin = useBuySellStore.use.setStableCoin()
  const { enableCadcSolana } = useFeatureFlags()

  useEffect(() => {
    if (preferencesLoaded) {
      return
    }

    const loadUserPreferences = async () => {
      try {
        if (!authToken) {
          setPreferencesLoaded(true)
          return
        }

        const res = await PaytrieAPI.getCurrentUser()

        if (res.status !== 200) {
          console.log('Could not fetch user for preferences')
          setPreferencesLoaded(true)
          return
        }

        const userId = res.data.data.id

        if (!userId) {
          console.log('No user ID found')
          setPreferencesLoaded(true)
          return
        }

        const preference = getUserTokenPreference(userId, enableCadcSolana)

        if (preference) {
          console.log('Applying saved user preferences:', preference)

          // Set network first to ensure stableCoin is valid for that network
          setNetwork(preference.network, enableCadcSolana)
          setStableCoin(preference.stableCoin)

          setPreferencesApplied(true)
        } else {
          console.log('No saved preferences found for user')
        }
      } catch (error) {
        console.error('Error loading user preferences:', error)
      } finally {
        setPreferencesLoaded(true)
      }
    }

    loadUserPreferences()
  }, [
    authToken,
    preferencesLoaded,
    setNetwork,
    setStableCoin,
    enableCadcSolana,
  ])

  return {
    preferencesLoaded,
    preferencesApplied,
  }
}
